//custom.js
$(document).ready(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 0) {
      $('.header-top').addClass('active');
    } else {
      $('.header-top').removeClass('active');
    }
  });
  $('#Details-menu-drawer-container').click(function () {
    $('#menu-drawer').toggleClass('is-open');
    $('.header-top').toggleClass('is-open');
    $('body').toggleClass('is-open');
  });
});

// 
(function() {
  const interval = setInterval(() => {
    const span = document.querySelector('.gw-drawer-open-btn__text');
    if (span) {
      span.style.display = 'block';  // display を block に変更
      clearInterval(interval);        // 適用できたら監視終了
    }
  }, 100); // 100msごとにチェック
})();

// 内部施策42
window.addEventListener("load", function () {
  document.querySelectorAll(".ac-box").forEach(function (box) {
    const txt = box.querySelector(".ac-txt");
    const btn = box.querySelector(".readmore-btn");
    if (!txt || !btn) return;

    btn.addEventListener("click", function () {
      txt.classList.toggle("open");
      btn.textContent = txt.classList.contains("open")
        ? "閉じる"
        : "他の商品カテゴリーを見る";
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {

  const swipers = document.querySelectorAll(".collection-swiper");

  swipers.forEach(function(swiperEl) {
    new Swiper(swiperEl, {
      slidesPerView: 3,
      spaceBetween: 20,
      speed: 1000,
      autoplay: {
        delay: 1500,
      },
      loop: true,

      pagination: {
        el: swiperEl.querySelector(".swiper-pagination"),
        clickable: true,
      },

      navigation: {
        nextEl: swiperEl.querySelector(".swiper-button-next"),
        prevEl: swiperEl.querySelector(".swiper-button-prev"),
      },

      breakpoints: {
        320: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        992: { slidesPerView: 3 },
        1024: { slidesPerView: 4 }
      }
    });
  });

});